
export interface Permission {
  name: string;
  settingsInstitue: boolean;
  settingsEsk: boolean;
  category: PermissionCategory;
}

export enum PermissionCategory {
  Admin = "admin",
  Prescription = "prescription",
  Task = "task",
  Patient = "patient",
  Planning = "planning",
  Accounting = "accounting",
}

export interface GroupedPermissions {
  category: PermissionCategory;
  perms: Permission[];
}

export const PermissionsArray: Permission[] = [
  { name: "ADMIN_INSTITUTE", settingsInstitue: true, settingsEsk: true, category: PermissionCategory.Admin },

  { name: "WRITE_PRESCRIPTION", settingsInstitue: false, settingsEsk: false, category: PermissionCategory.Prescription },
  { name: "READ_PRESCRIPTION", settingsInstitue: false, settingsEsk: false, category: PermissionCategory.Prescription },
  { name: "SIGN_PRESCRIPTION", settingsInstitue: true, settingsEsk: true, category: PermissionCategory.Prescription },

  { name: "ACCESS_TASK", settingsInstitue: false, settingsEsk: true, category: PermissionCategory.Task },

  { name: "ADD_PATIENT_DOCUMENT", settingsInstitue: false, settingsEsk: false, category: PermissionCategory.Patient },
  { name: "MODIFY_PATIENT_DATA", settingsInstitue: true, settingsEsk: false, category: PermissionCategory.Patient },
  { name: "READ_PATIENT_DATA", settingsInstitue: true, settingsEsk: false, category: PermissionCategory.Patient },
  { name: "DELETE_PATIENT_DOCUMENT", settingsInstitue: false, settingsEsk: false, category: PermissionCategory.Patient },
  { name: "EDIT_PATIENT_ADMIN_DATA", settingsInstitue: true, settingsEsk: false, category: PermissionCategory.Patient },

  { name: "ACCESS_PLANNING", settingsInstitue: false, settingsEsk: true, category: PermissionCategory.Planning },
  { name: "OWNER_PLANNING", settingsInstitue: true, settingsEsk: false, category: PermissionCategory.Planning },

  { name: "ACCESS_ACCOUNTING", settingsInstitue: false, settingsEsk: true, category: PermissionCategory.Accounting }
];

type PermissionNamespace = Record<string, Record<string, Permission>>;

export const Permissions: PermissionNamespace = PermissionsArray.reduce((acc, perm) => {
  if (!acc[perm.category]) acc[perm.category] = {};
  acc[perm.category][perm.name] = perm;
  return acc;
}, {} as PermissionNamespace);

export const PermissionsAdmin = {
  esklepios: {
    ADMIN_ESKLEPIOS: "ADMIN_ESKLEPIOS"
  }
} as const;
